// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
// Parts
import Table, { TableApiParamsType, TableHashCacheType } from "../../components/Table";
// Engine
import { axiosAPI } from "../../../engine/config/axios";

const Holidays:FC<TableHashCacheType> = (props) => {
  const { hashCache } = props;
  const gridParams = {
    grids: [{ name: 'holidays', hashCache }],
  }

  const apiParams: TableApiParamsType = (loadOptions, pageParams) => ({
      filters: loadOptions?.filter,
      sort: loadOptions?.sort,
      ...pageParams
    });

  return <Table
    api={axiosAPI.holidays.table}
    apiParams={apiParams}
    gridParams={gridParams}
    gridName="holidays"
    sortingMode="multiple"
  />;
}

function HolidaysPortal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<Holidays hashCache={Root?.dataset.hashCache} />, Root) : null;
}

export default HolidaysPortal;
